import {v4 as uuidv4} from 'uuid';
import {setRequestIdHeader} from '../config/axios';

export const setRequestId = () => {
  const guid = uuidv4();
  setRequestIdHeader(guid);
};
